import { Account } from "../services/accounts";
import { Institution } from "../services/institutions";


class Session {
  account: Account | undefined;
  institution: Institution | undefined;
  generation = 0;

  listeners: { [key: string]: Function[] } = {};

  getInstitution(): Institution {
    if (!this.institution) throw 'Expected session.institution, but not set.';
    return this.institution;
  }

  setInstitution(institution: Institution) {
    if (this.institution?.id !== institution.id) this.generation++;
    this.institution = institution;
    localStorage.institution = JSON.stringify(institution);
    this.emit('change');
  }

  getAccount(): Account {
    if (!this.account) throw 'Expected session.account, but not set.';
    return this.account;
  }

  setAccount(account: Account) {
    if (this.account?.id !== account.id) this.generation++;
    this.account = account;
    localStorage.account = JSON.stringify(account);
    this.emit('change');
  }

  setSession(account: Account, institution: Institution) {
    if (this.account?.id !== account.id || this.institution?.id !== institution.id) this.generation++;
    this.account = account;
    this.institution = institution;
    try {
      localStorage.account = JSON.stringify(account);
      localStorage.institution = JSON.stringify(institution);
    } catch {
      // Keep fresh data usable in memory when browser storage is unavailable.
    }
    this.emit('change');
  }

  reset() {
    this.generation++;
    delete localStorage.account;
    delete localStorage.institution;
    this.account = undefined;
    this.institution = undefined;
    this.emit('reset');
  }

  constructor() {
    if (localStorage.account) this.setAccount(JSON.parse(localStorage.account));
    if (localStorage.institution) this.setInstitution(JSON.parse(localStorage.institution));
    this.listeners = {};

    if (!this.account || !this.institution) delete localStorage.accessToken;
  }

  hasPermission(perm: string): boolean {
    if (!this.account) return false;
    return this.account.permissions.indexOf(perm) > -1;
  }

  on(listenerId: string, callback: Function) {
    if (!this.listeners[listenerId]) this.listeners[listenerId] = [];
    this.listeners[listenerId].push(callback);
  }

  off(listenerId: string, callback: Function) {
    if (!this.listeners[listenerId]) return;
    this.listeners[listenerId] = this.listeners[listenerId].filter(listener => listener !== callback);
  }

  emit(listenerId: string, ...args: any[]) {
    if (!this.listeners[listenerId]) return;
    this.listeners[listenerId].forEach(callback => callback(...args));
  }

}

const session = new Session();

export { session }
